import { styled } from '@mui/material';

export const StyledFormContainer = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
});

export const StyledContentContainer = styled('div')({
  display: 'flex',
  gap: '12px',
  flexDirection: 'column',
});
